import { z } from "zod";
import {
  medicalCompetenceSchema,
  type IMedicalCompetence,
} from "@medoma/models/shifts";
import { useEnabledCompetences, type ShiftsWithContents } from "@/api/Shifts";
import { useSelectedFilter } from "./useSelectedFilter";

export const applyCompetenceFilter = (
  data: ShiftsWithContents,
  selected: ReadonlySet<IMedicalCompetence>,
  allSelected: boolean,
): ShiftsWithContents => {
  if (allSelected) {
    return data;
  }
  return {
    before: data.before.filter(({ shift }) => selected.has(shift.competence)),
    relevant: data.relevant.filter(({ shift }) =>
      selected.has(shift.competence),
    ),
    after: data.after.filter(({ shift }) => selected.has(shift.competence)),
  };
};

const selectedCompetencesSchema = z.array(medicalCompetenceSchema);

export const useCompetenceFilter = () => {
  const { data: enabledCompetences } = useEnabledCompetences();
  return useSelectedFilter({
    storageKey: "planning-selected-competences",
    schema: selectedCompetencesSchema,
    enabledIds: enabledCompetences,
  });
};
